import { RightOutlined } from '@ant-design/icons';
import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import { Flex } from '@/components/base';
import { SpanStyle } from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import useInsightExplorerStore from '@/stores/InsightExplorerStore';

import useExplorerSelect from '../../hooks/useExplorerSelect';
import type { BreadcrumbItem } from './types';

const BreadcrumbSection = () => {
  const { findNode, selectedNode } = useInsightExplorerStore();
  const selectNode = useExplorerSelect();
  const colors = useColor();

  const breadcrumbItems: BreadcrumbItem[] = useMemo(() => {
    if (!selectedNode) return [];

    // 현재는 selectedNode만 표시
    return selectedNode.path.map((path, index, arr) => ({
      label: path.label,
      value: path.value,
      current: index === arr.length - 1,
    }));
  }, [selectedNode]);

  return (
    <Flex a="center" g={6}>
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={index}>
          <BreadCrumbItem
            isCurrent={item.current}
            onClick={() => {
              if (item.current) return;
              const node = findNode(item.value as string);

              if (node) {
                selectNode(node);
              }
            }}
          >
            {item.label}
          </BreadCrumbItem>
          {index < breadcrumbItems.length - 1 && (
            <RightOutlined
              style={{ fontSize: '10px', color: colors.gray500 }}
            />
          )}
        </React.Fragment>
      ))}
    </Flex>
  );
};

export const BreadCrumbItem = styled.span<{
  isCurrent?: boolean;
  isRoot?: boolean;
}>`
  ${SpanStyle({
    type: 'label2',
    weight: 'm',
  })};
  color: ${({ theme }) => theme.colors.gray500};
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.colors.primary100};
  }
  ${({ isCurrent }) =>
    isCurrent &&
    css`
      cursor: text;
      color: ${({ theme }) => theme.colors.gray800};
      &:hover {
        color: ${({ theme }) => theme.colors.gray800};
      }
    `}
  ${({ isRoot }) =>
    isRoot &&
    css`
      cursor: text;
      color: ${({ theme }) => theme.colors.gray500};
      &:hover {
        color: ${({ theme }) => theme.colors.gray500};
      }
    `}
`;

export default BreadcrumbSection;
